"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const replaceFill_1 = __importDefault(require("./replaceFill"));
const CMSIconContext_1 = require("./CMSIconContext");
function useCMSIcon(name, color, noEmitError) {
    const iconsQuery = (0, react_1.useContext)(CMSIconContext_1.IconsContext);
    if (!iconsQuery)
        return undefined;
    const icons = iconsQuery.nodes;
    if (!icons)
        throw new Error(`Icons not found in iconsQuery result. ` +
            `Check return value from useIconsQuery().`);
    if (icons.length === 0) {
        if (noEmitError)
            return undefined;
        throw new Error(`No icons found in icons context. Does a parent ` +
            `component include the <CMSIconsProvider /> ` +
            `component and is that component passed a non-empty ` +
            `result from useCMSIconsQuery() query hook? `);
    }
    const icon = icons.find(icon => icon.data.Name === name);
    if (!(icon === null || icon === void 0 ? void 0 : icon.data.SVG)) {
        if (noEmitError === true)
            return undefined;
        throw new Error(`Icon ${name} not found in ` +
            `Airtable. Does the airtable base include the ` +
            `Icons table, and does that table include ` +
            `an icon called ${name}?`);
    }
    let svgString = icon.data.SVG.localFiles[0].childSvg.svgString;
    if (color)
        svgString = (0, replaceFill_1.default)(icon.data.SVG.localFiles[0].childSvg.svgString, color);
    return { text: icon.data.Text, svg: svgString };
}
exports.default = useCMSIcon;
//# sourceMappingURL=useCMSIcon.js.map